import React from 'react';
import AUIInputTextField from '@ancert/aui-input-text-field';
import AUIInputSwitchField from '@ancert/aui-input-switch-field';
import AUIDropDownField from '@ancert/aui-dropdown-field';

import { useFormularDenuncia } from '../../context/formularDenuncia.context';
import MAESTRO_TIPO_DOC from '../../constants/maestros.constants';

const DatosPersonales = () => {
  const { control, formState, watch } = useFormularDenuncia();
  const isAnonimo = watch('isAnonimo');

  return (
    <div className="u-mt-24">
      <h2>Datos personales</h2>
      <div className="o-grid u-mt-16">
        <div className="o-grid__row">
          <div className="o-grid__col-12">
            <AUIInputSwitchField
              classNameField="c-sii-field--no-feedback"
              controlRef={control}
              description="Comunicación anónima"
              errors={formState.errors}
              name="isAnonimo"
            />
          </div>
        </div>
        {!isAnonimo ? (
          <>
            <p className="u-mt-16">
              Al enviar su primera denuncia, se le creará una contraseña provisional para hacer el seguimiento de dicha
              denuncia. Al acceder por primera vez al seguimiento de la denuncia, deberá cambiar la contraseña.
            </p>
            <div className="o-grid__row u-mt-16">
              <div className="o-grid__col-4">
                <AUIInputTextField required label="Nombre" name="name" controlRef={control} errors={formState.errors} />
              </div>
              <div className="o-grid__col-4">
                <AUIInputTextField
                  required
                  label="Primer apellido"
                  name="lastname1"
                  controlRef={control}
                  errors={formState.errors}
                />
              </div>
              <div className="o-grid__col-4">
                <AUIInputTextField
                  label="Segundo apellido"
                  name="lastname2"
                  controlRef={control}
                  errors={formState.errors}
                />
              </div>
            </div>
            <div className="o-grid__row">
              <div className="o-grid__col-4">
                <AUIInputTextField
                  label="Teléfono"
                  name="phone"
                  controlRef={control}
                  errors={formState.errors}
                  keyfilter="pint"
                />
              </div>
              <div className="o-grid__col-4">
                <AUIDropDownField
                  appendTo={null}
                  required
                  label="Tipo de documento"
                  name="documentType"
                  placeholder="Seleccionar"
                  controlRef={control}
                  errors={formState.errors}
                  options={MAESTRO_TIPO_DOC}
                />
              </div>
              <div className="o-grid__col-4">
                <AUIInputTextField
                  required
                  label="Documento"
                  name="document"
                  controlRef={control}
                  errors={formState.errors}
                />
              </div>
            </div>
            <div className="o-grid__row">
            <div className="o-grid__col-4">
                <AUIInputTextField required label="Email" name="email" controlRef={control} errors={formState.errors} />
              </div>
              <div className="o-grid__col-4">
                <AUIInputTextField label="Cargo" name="position" controlRef={control} errors={formState} />
              </div>
              <div className="o-grid__col-4">
                <AUIInputTextField
                  label="Dirección"
                  name="address"
                  controlRef={control}
                  errors={formState.errors}
                  placeholder="Ej: calle"
                />
              </div>
            </div>
          </>
        ) : (
          <div className="o-sii-desc-container">
            <p> Se realizará la comunicación de forma anónima.</p>
            <p className="u-mt-16">
              Al enviar la denuncia, se le creará un usuario formado por una combinación alfanumérica y una contraseña
              provisional para hacer el seguimiento de laa denuncia. Al acceder por primera vez al seguimiento de la
              denuncia deberá cambiar la contraseña.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
DatosPersonales.propTypes = {};
DatosPersonales.defaultProps = {};

export default DatosPersonales;
